import { ImgHTMLAttributes } from "react";

export interface AppLogoProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, "src" | "alt"> {}

const AppLogo = (props: AppLogoProps) => {
  return (
    <img alt="Ximly logo" src={"https://public-assets.ximly.app/ximly-long.webp"} {...props} />
  );
};

export default AppLogo;
